(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-settings-handler"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="#cookie-settings"]');
    if (!link) return;
    e.preventDefault();
    if (typeof showCookieBanner === 'function') showCookieBanner();
  });
  } catch(e) { console.error(e); }
})();

})();
